<template>

  <div class="lotti-child-sessions-module">

    <div class="lotti-module-title">Therapiestunden</div>

    <div class="lotti-module-nav">

      <el-input
          size="medium"
          placeholder="Suchtext"
          v-model="searchForm.text">
      </el-input>

      <el-button
          size="mini"
          class="lotti-search-info-popover"
          v-popover:popover-search-child
          round>
        ?
      </el-button>

      <el-popover
          ref="popover-search-child"
          placement="top-start"
          width="250"
          trigger="hover"
          content="Durchsuchbare Felder: ID, Dauer, Kategorie, Status">
      </el-popover>

    </div>

    <el-table :data="tableData"
              class="lotti-module-table"
              ref="sessionTable"
              height="490px"
              stripe
              :row-key="tableData.id"
              :default-sort="searchForm.sortingParams"
              @sort-change="setSortingParams"
              @row-click="openSession"
              @hook:mounted="tableMounted"
              @hook:beforeDestroy="tableBeforeDestroy"
              style="width: 100%">

      <el-table-column
          prop="datetime_start"
          label="Datum"
          sortable="custom"
          width="100px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ datePickerHelper.formatUTCDateCH(scope.row.datetime_start) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="duration"
          label="Dauer"
          sortable="custom"
          width="100px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ scope.row.duration + ' min' }}
        </template>
      </el-table-column>

      <el-table-column
          prop="category"

          label="Kategorie"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="status"
          label="Status"
          width="90px"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

    </el-table>

  </div>

</template>

<script>
import auth from '../../auth.js';
import Vue from "../../main";
import datePickerHelper from "../../Helpers/DatePickerHelper";

export default {

  props: {
    childId: Number,
  },

  data() {
    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      submitDelay: 400,//ms
      submitTimer: null,

      pageNumber: 0,
      tableData: [],
      thereIsMoreData: true,
      allowedSorting: ['ascending', 'descending'],
      tableSelector: '.lotti-child-sessions-module .el-table__body-wrapper',
      tableElement: null,

      searchForm: {

        text: '',

        sortingParams: {
          prop: 'datetime_start',
          order: 'descending'
        }
      }
    }
  },

  methods: {

    setSortingParams(column, prop, order) {
      this.searchForm.sortingParams.prop = column.prop;
      this.searchForm.sortingParams.order = column.order;
    },

    openSession(row, event, column) {
      this.$router.push({
        name: 'session',
        params: {
          sessionId: row.id,
          goBackOneHistoryStep: true,
        }
      })
    },

    getAllChildSession() {

      // childId is 0 or null, dont load data
      if(!this.childId) return;

      //increase page number BEFORE submitting!
      this.pageNumber += 1;

      Vue.http.get(
          'api/v1/session/get-all-my',
          {
            params: {
              text: this.searchForm.text,
              child_id: this.childId,
              column: this.searchForm.sortingParams.prop,
              order: this.searchForm.sortingParams.order === 'ascending' ? 'asc' : 'desc',
              page: this.pageNumber
            }
          }
      ).then(response => {

        //concat the data at the end of the already loaded data if != null
        if (response.data) {
          this.tableData = this.tableData.concat(response.data);
        } else {
          //block further requests, there is no more data
          this.thereIsMoreData = false;
        }

      }, response => {
        // this.showError(response.data.message);
      })
    },

    resetTableLoader() {
      this.pageNumber = 0;//reset page size on filter change
      this.tableData = [];//reset tableData as well

      //allow loading for further data after reset
      this.thereIsMoreData = true;
    },

    sendDelayedSearchRequest() {
      //if timer exists: clear
      if (this.submitTimer) {
        clearTimeout(this.submitTimer);
        this.submitTimer = null;
      }
      this.submitTimer = setTimeout(() => {
        this.getAllChildSession();
      }, this.submitDelay);
    },

    handleOnInfiniteScroll(event) {
      //implement infinite scroll
      if (
          this.thereIsMoreData &&
          Math.ceil(this.tableElement.clientHeight + this.tableElement.scrollTop) >= this.tableElement.scrollHeight
      ) {
        // you're at the bottom of the page
        this.getAllChildSession();
      }
    },

    tableMounted() {
      //select table element first
      this.tableElement = document.querySelector(this.tableSelector);
      //add event listener secondly
      this.tableElement.addEventListener('scroll', this.handleOnInfiniteScroll);
    },

    tableBeforeDestroy() {
      this.tableElement.removeEventListener('scroll', this.handleOnInfiniteScroll);
    }
  },

  watch: {
    searchForm: {
      handler(newValue, oldValue) {
        this.resetTableLoader();//reset values on each form filter change
        this.sendDelayedSearchRequest();
      },
      deep: true,
    }
  },

  beforeMount() {

    //get all therapists in selected service
    this.getAllChildSession();
  },

  mounted() {

  }
}

</script>